/**
 * @generated SignedSource<<505fc6446b8601271a39ed2642f18c1c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type InspectionfieldStateEnum = "APPROVED" | "ASSIGNED" | "IN_PROGRESS" | "OPEN" | "PLANNED" | "REJECTED" | "RETRY" | "%future added value";
export type QueriesInspectionListMutation$variables = {
  id: string;
  state: InspectionfieldStateEnum;
  timestamp: number;
};
export type QueriesInspectionListMutation$data = {
  readonly modifyInspectionfieldDate: {
    readonly inspectionfield: {
      readonly id: string;
      readonly latestInspection: {
        readonly approvedDate: any | null;
        readonly lastModified: any | null;
        readonly rejectedDate: any | null;
        readonly retryDate: any | null;
      } | null;
      readonly plannedDate: any | null;
      readonly state: InspectionfieldStateEnum | null;
    } | null;
  } | null;
};
export type QueriesInspectionListMutation = {
  response: QueriesInspectionListMutation$data;
  variables: QueriesInspectionListMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "state"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "timestamp"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "state",
        "variableName": "state"
      },
      {
        "kind": "Variable",
        "name": "timestamp",
        "variableName": "timestamp"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plannedDate",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastModified",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "approvedDate",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "retryDate",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rejectedDate",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "QueriesInspectionListMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ModifyInspectionfieldDatePayload",
        "kind": "LinkedField",
        "name": "modifyInspectionfieldDate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "InspectionfieldNode",
            "kind": "LinkedField",
            "name": "inspectionfield",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "InspectionNode",
                "kind": "LinkedField",
                "name": "latestInspection",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "QueriesInspectionListMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ModifyInspectionfieldDatePayload",
        "kind": "LinkedField",
        "name": "modifyInspectionfieldDate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "InspectionfieldNode",
            "kind": "LinkedField",
            "name": "inspectionfield",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "InspectionNode",
                "kind": "LinkedField",
                "name": "latestInspection",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4d03bbbfe76d83b6e60a6d75b5f9991a",
    "id": null,
    "metadata": {},
    "name": "QueriesInspectionListMutation",
    "operationKind": "mutation",
    "text": "mutation QueriesInspectionListMutation(\n  $id: ID!\n  $state: InspectionfieldStateEnum!\n  $timestamp: Float!\n) {\n  modifyInspectionfieldDate(input: {id: $id, timestamp: $timestamp, state: $state}) {\n    inspectionfield {\n      id\n      state\n      plannedDate\n      latestInspection {\n        lastModified\n        approvedDate\n        retryDate\n        rejectedDate\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9b8df96fd8a24c70028b80b0bb61994e";

export default node;
